import { TestImage } from "@assets/constant/index.constant";
import { Button } from "@components/ui/button";
import { endpoint } from "@services/api.services";
import { GeneralCard, TableCard } from "@ui/internal/components/card";
import { usePathname } from "@utils/hook/index.hook";
import { QueryData } from "@utils/interface/index.interface";
import { useListData } from "@utils/query/index.query";
import React from "react";
import { Link, NavLink, useSearchParams } from "react-router";
import { ColumnList } from "./column/index.column";
import AddMatchForm from "./form/index.form";
import { useMetaStore } from "@utils/states/index.state";
import { format } from "date-fns";
import { Settings, Settings2 } from "lucide-react";
type Props = {};
const index: React.FC<Props> = ({}) => {
  const [searchParams] = useSearchParams();
  const pathname = usePathname();

  const columns = ColumnList();
  const { search, date } = useMetaStore();
  /* ================================================= api calls logic ================================================= */
  const { data, refetch, isPending } = useListData<QueryData<any>>({
    params: {
      page: searchParams.get("tpage") || 1,
      size: searchParams.get("per") || 10,
      ordering: searchParams.get("ordering") || "order",
      // search: search,
      // created_date__gte: date.from ? format(date.from, "yyyy-MM-dd") : "",
      // created_date__lte: date.to ? format(date.to, "yyyy-MM-dd") : "",
    },
    endpoint: endpoint["cricket-match"],
    key: `${pathname}-listing`,
    window: true,
  });
  return (
    <>
      <TableCard
        bulkActions
        table_content={{
          mode: "default",
          type: "match",
        }}
        inject_ui_table_actions={
          <>
            {/* <FilterPopover
              filters={[
                {
                  label: "Student",
                  endpointValue: "student",
                  format: {
                    key: "email",
                    value: "id",
                  },
                },
              ]}
              title="Filter"
              triggerText="Filter"
            /> */}
            <Link to="/cricket-match/winners">
              <Button variant="defaultoutline">
                <Settings />
                Manage Winners
              </Button>{" "}
            </Link>
          </>
        }
        orientationPosition={false}
        endpoint={endpoint["cricket-match"]}
        grid={
          <GeneralCard
            showCheck
            content={{
              image: TestImage,
              title: "Focused Mode",
              tags: ["Clarity"],
            }}
            onDelete={() => {}}
            onEdit={() => {}}
          />
        }
        refetch={refetch}
        isPending={isPending}
        columns={columns}
        // columns={[]}
        sortableFilter={{
          search: search,
          created_date__gte: date.from ? format(date.from, "yyyy-MM-dd") : "",
          created_date__lte: date.to ? format(date.to, "yyyy-MM-dd") : "",
          course_batch: searchParams.get("course-batch") || null,
          payment_mode: searchParams.get("payment-mode") || null,
          is_masterclass: pathname == "masterclass-payment" ? true : false,
        }}
        rows={data?.data?.results ?? []}
        count={data?.data?.count ?? 10}
        form={<AddMatchForm />}
      />
    </>
  );
};

export default index;
